import { useEffect, useRef, useState } from 'react';
import ArrowDown from '../../assets/arrow-down.svg?react';
import { getStickyButtonOnHoverClassNames } from '../../lib/getStickyButtonOnHoverClassNames';

interface CustomDropdownProps {
	options: { title: string; id: string }[];
	currentLabel: string | undefined;
	handleOptionSelect: (elementId: string) => void;
	backgroundColorClass: string;
}

export const CustomDropdown = ({
	options,
	currentLabel,
	handleOptionSelect,
	backgroundColorClass,
}: CustomDropdownProps) => {
	const [toggle, setToggle] = useState<boolean>(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const handleClickOutside = (event: MouseEvent) => {
		if (
			dropdownRef.current &&
			!dropdownRef.current.contains(event.target as Node)
		) {
			setToggle(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={dropdownRef} className="relative w-full bg-red lg:hidden">
			<div
				className="flex items-center justify-between px-5 py-4 cursor-pointer"
				onClick={() => setToggle(!toggle)}
			>
				<div className="font-bold">{currentLabel}</div>
				<ArrowDown height={25} width={25} />
			</div>
			{toggle ? (
				<div className={`absolute w-full mt-[-1px] ${backgroundColorClass} shadow-md`}>
					{options.map((option) => (
						<div
							key={option.id}
							className={`px-5 py-2 cursor-pointer font-bold ${getStickyButtonOnHoverClassNames(backgroundColorClass)}`}
							onClick={() => {
								handleOptionSelect(option.id);
								setToggle(false);
							}}
						>
							{option.title}
						</div>
					))}
				</div>
			) : null}
		</div>
	);
};
